export default __webpack_public_path__ + "static/pro-team-13bfcf0ae648f8530106057e9ee6fa82.png";